import { NW_PLUS } from '../paths';

export default {
  text: {
    auth: 'Upgrade your membership with NerdWallet+ and earn rewards worth up to $350',
    unauth:
      'Join NerdWallet+ to earn rewards worth up to $350 for making smart financial decisions.',
  },
  ctaText: 'Join for $49',
  ctaLink: NW_PLUS,
  campaign: 'NW+',
  campaignKey: 'nw_plus',
};
